// extracted by mini-css-extract-plugin
module.exports = {"news-banner-box":"bd","newsBannerBox":"bd","banner-wrap":"be","bannerWrap":"be","banner-title":"bf","bannerTitle":"bf","banner-img-box":"bg","bannerImgBox":"bg"};